var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-modal",
    {
      attrs: {
        id: "repositoryCreateRepositoryModal",
        size: "md",
        "hide-header-close": "",
        "no-stacking": "",
        title: _vm.$t("admin.create_repository"),
      },
      on: {
        hide: function ($event) {
          return _vm.resetValues()
        },
      },
      scopedSlots: _vm._u([
        {
          key: "modal-footer",
          fn: function ({ cancel }) {
            return [
              _c(
                "b-button",
                {
                  attrs: { size: "md", variant: "secondary" },
                  on: {
                    click: function ($event) {
                      return cancel()
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("message.close")))]
              ),
              _c(
                "b-button",
                {
                  attrs: { size: "md", variant: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.createRepository()
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("message.create")))]
              ),
            ]
          },
        },
      ]),
    },
    [
      _c("b-validated-input-group-form-input", {
        attrs: {
          id: "identifier",
          label: _vm.$t("admin.identifier"),
          "input-group-size": "mb-3",
          rules: "required",
        },
        model: {
          value: _vm.identifier,
          callback: function ($$v) {
            _vm.identifier = $$v
          },
          expression: "identifier",
        },
      }),
      _c("b-validated-input-group-form-input", {
        attrs: {
          id: "url",
          label: _vm.$t("admin.url"),
          "input-group-size": "mb-3",
          rules: "required",
          type: "url",
        },
        model: {
          value: _vm.url,
          callback: function ($$v) {
            _vm.url = $$v
          },
          expression: "url",
        },
      }),
      _c("b-input-group-form-select", {
        attrs: {
          id: "input-repository-type",
          required: "true",
          options: _vm.repositoryTypes,
          label: _vm.$t("admin.repository_type"),
        },
        model: {
          value: _vm.repositoryType,
          callback: function ($$v) {
            _vm.repositoryType = $$v
          },
          expression: "repositoryType",
        },
      }),
      _c(
        "div",
        [
          _c(
            "c-switch",
            _vm._b(
              {
                attrs: { color: "primary", label: "" },
                model: {
                  value: _vm.internal,
                  callback: function ($$v) {
                    _vm.internal = $$v
                  },
                  expression: "internal",
                },
              },
              "c-switch",
              _vm.labelIcon,
              false
            )
          ),
          _vm._v(_vm._s(_vm.$t("admin.internal")) + "\n  "),
        ],
        1
      ),
      _c(
        "div",
        [
          _c(
            "c-switch",
            _vm._b(
              {
                attrs: { color: "primary", label: "" },
                model: {
                  value: _vm.repository_authentication,
                  callback: function ($$v) {
                    _vm.repository_authentication = $$v
                  },
                  expression: "repository_authentication",
                },
              },
              "c-switch",
              _vm.labelIcon,
              false
            )
          ),
          _vm._v(_vm._s(_vm.$t("admin.repository_authentication")) + "\n  "),
        ],
        1
      ),
      _c("b-validated-input-group-form-input", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.repository_authentication,
            expression: "repository_authentication",
          },
        ],
        attrs: {
          id: "username",
          label: _vm.$t("admin.username"),
          "input-group-size": "mb-3",
          rules: "required",
        },
        model: {
          value: _vm.username,
          callback: function ($$v) {
            _vm.username = $$v
          },
          expression: "username",
        },
      }),
      _c("b-validated-input-group-form-input", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.repository_authentication,
            expression: "repository_authentication",
          },
        ],
        attrs: {
          id: "password",
          label: _vm.$t("admin.password"),
          "input-group-size": "mb-3",
          type: "password",
          rules: "required",
        },
        model: {
          value: _vm.password,
          callback: function ($$v) {
            _vm.password = $$v
          },
          expression: "password",
        },
      }),
      _c(
        "div",
        [
          _c(
            "c-switch",
            _vm._b(
              {
                attrs: { color: "primary", label: "" },
                model: {
                  value: _vm.enabled,
                  callback: function ($$v) {
                    _vm.enabled = $$v
                  },
                  expression: "enabled",
                },
              },
              "c-switch",
              _vm.labelIcon,
              false
            )
          ),
          _vm._v(_vm._s(_vm.$t("admin.enabled")) + "\n  "),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }